"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function concatPathnameQuery(pathname, searchParams) {
    const searchString = typeof searchParams === 'object' ? searchParams.toString() : searchParams;
    return pathname + (searchString ? `?${searchString}` : '');
}
exports.default = concatPathnameQuery;
//# sourceMappingURL=concatPathnameQuery.js.map